import { render, staticRenderFns } from "./CustomStyling.vue?vue&type=template&id=be82696c"
import script from "./CustomStyling.vue?vue&type=script&lang=js"
export * from "./CustomStyling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports